(() => {
  if (window.__tcfGalleryV114Loaded) return;
  window.__tcfGalleryV114Loaded = true;

  function activate(tab) {
    const gallery = tab.closest('[data-tcf-gallery]');
    if (!gallery) return;
    const target = tab.dataset.tcfGalleryTab;

    gallery.querySelectorAll('[data-tcf-gallery-slide]').forEach((slide) => {
      const active = slide.dataset.tcfGallerySlide === target;
      slide.hidden = !active;
      slide.classList.toggle('is-active', active);
    });

    gallery.querySelectorAll('[data-tcf-gallery-tab]').forEach((button) => {
      const active = button === tab;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', active ? 'true' : 'false');
      button.tabIndex = active ? 0 : -1;
    });
  }

  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-tcf-gallery-tab]');
    if (tab) activate(tab);
  });

  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest('[data-tcf-gallery-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const gallery = tab.closest('[data-tcf-gallery]');
    const tabs = Array.from(gallery.querySelectorAll('[data-tcf-gallery-tab]'));
    const current = tabs.indexOf(tab);
    let next = current;
    if (event.key === 'ArrowRight') next = (current + 1) % tabs.length;
    if (event.key === 'ArrowLeft') next = (current - 1 + tabs.length) % tabs.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = tabs.length - 1;
    event.preventDefault();
    tabs[next].focus();
    activate(tabs[next]);
  });
})();
